export const DEBOUNCE_DELAY = 300;

export const DOC_CATEGORIES_LIMIT_PER_PAGE = 60;

export const HIDDEN_CATEGORIES = [0]; //"Тип не обрано"
